// extracted by mini-css-extract-plugin
export default {"tag-item":"format-tags_tag-item__+wiJI","wrapper":"format-tags_wrapper__88B2V"};